import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { ProductCard } from './components';
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionGetDisplayAreasByType, actionResetDisplayAreas } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetBookingTypes } from 'actions';
import { actionCalendarNavReset } from 'actions';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  TourPaddingLS: {
    paddingTop: "100px"
  },
  TourPaddingSS: {
    paddingTop: "50px"
  }
}));

const ProductList = (props) => {

  const constredirect = (product) => {

    if (product.hasOwnProperty("UniqueBookingTypeID")) {
      props.history.push({
        pathname: '/calendar/' + product.UniqueBookingTypeID
      })
    }
    else {
      props.history.push({
        pathname: '/calendar/Area/' + product.DisplayAreaNo
      })
    }

  }

  const dispatch = useDispatch()

  useEffect(() => {
    actionGetDisplayAreasByType(dispatch, "bookingtypes", null, false);
    actionCalendarNavReset(dispatch);
  }, []);


  const classes = useStyles();
  const displayAreasState = useSelector(state => state.reducerDisplayAreas);
  const error = useSelector(state => state.reducerDisplayAreas.displayAreasError);
  const events = useSelector(state => state.reducerShopCart.events);
  const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);

  if (events && events.length < 1 && bookingTypes && bookingTypes.length > 0) {
    actionResetBookingTypes(dispatch);
  }

  useEffect(() => {

    if (displayAreasState.loading == true) {
      actionStartAppLoader(dispatch);
    }
    else {
      actionEndAppLoader(dispatch);
    }

  })

  const errorcancelhandle = () => {
    actionResetDisplayAreas(dispatch);
  }

  if (displayAreasState.displayAreas === undefined) {
    return <div>
      <ErrorHandling msg={error} open={error.length > 0 ? true : false}
        handleclose={errorcancelhandle} />
    </div>
  }

  return (

    <div className={classes.root}>

      <div className={classes.content}>
        <Grid
          container
          spacing={2}
          style={{ paddingTop: window.matchMedia("(max-width: 500px)").matches ? 35 : 5 }}
        >
          {displayAreasState.displayAreas.map((area, i) => {
            return area.ShowOnline && area !== undefined ?
              <Grid
                item
                key={area.DisplayAreaNo}
                lg={4}
                md={6}
                xs={12}

              >
                <ProductCard area={area} callCalender={constredirect} />
              </Grid>

              : null
          })}

        </Grid>
      </div>
    </div>
  );
};

export default ProductList;
